import { render, staticRenderFns } from "./ReturnTrail.vue?vue&type=template&id=0ff0a931"
import script from "./ReturnTrail.vue?vue&type=script&lang=ts"
export * from "./ReturnTrail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports